import api from '@/lib/api';

export type UserActivityLevel = 'info' | 'warning' | 'error';

export interface UserActivityEntry {
  _id: string;
  userId: string;
  type: string;
  level: UserActivityLevel;
  message: string;
  meta?: Record<string, unknown>;
  createdAt: string;
}

export interface UserActivityPage {
  items: UserActivityEntry[];
  pagination: {
    page: number;
    limit: number;
    total: number;
    totalPages: number;
    hasNextPage: boolean;
    hasPrevPage: boolean;
  };
}

export interface UserActivityParams {
  type?: string;
  level?: string;
  limit?: number;
}

/** GET /user-activity/:userId — timeline newest-first (super-admin). */
export async function getUserActivity(
  userId: string,
  page: number,
  params: UserActivityParams = {},
): Promise<UserActivityPage> {
  const res = await api.get(`/user-activity/${userId}`, {
    params: {
      page,
      limit: params.limit ?? 50,
      type: params.type || undefined,
      level: params.level || undefined,
    },
  });
  return res.data.data as UserActivityPage;
}
